// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6d10768a","239":"e39fb35b","403":"af680c37","455":"ba0306d1","508":"5f25d7c0","629":"db5ef904","776":"0721ddc3","946":"8508f210"}[chunkId] + ".chunk.js";
};